import React from 'react';
import { Grid, Box, Typography } from '@mui/material';
import DetailTemplate from '../../common/template/DetailTemplate';

const ProjectDetailInfo = ({ project, estimate }) => {
  return (
    <Box>
      <DetailTemplate title="기회 확인">
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          sx={{ py: 1, borderBottom: 1, borderColor: 'divider' }}
        >
          <Grid item xs={1}>
            <Typography variant="subtitle2" component="div">
              매출 타입
            </Typography>
          </Grid>
          <Grid item xs={2}>
            <Typography variant="body2" component="div">
              {project?.prjTyp === 'N' && '일반'}
              {project?.prjTyp === 'M' && '유지보수'}
              {project?.prjTyp === 'ETC' && '기타매출'}
            </Typography>
          </Grid>
          <Grid item xs={1}>
            <Typography variant="subtitle2" component="div">
              사업명
            </Typography>
          </Grid>
          <Grid item xs={4}>
            {' '}
            <Typography variant="body2" component="div">
              {project?.cstNm}
            </Typography>
          </Grid>
          <Grid item xs={1}>
            <Typography variant="subtitle2" component="div">
              고객명
            </Typography>
          </Grid>
          <Grid item xs={3}>
            <Typography variant="body2" component="div">
              {' '}
              {project?.partnerInc}
            </Typography>
          </Grid>
        </Grid>
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          sx={{ py: 1, borderBottom: 1, borderColor: 'divider' }}
        >
          <Grid item xs={1}>
            <Typography variant="subtitle2" component="div">
              기회구분
            </Typography>
          </Grid>
          <Grid item xs={2}>
            <Typography variant="body2" component="div">
              {project?.chanceTyp}
            </Typography>
          </Grid>
          <Grid item xs={1}>
            <Typography variant="subtitle2" component="div">
              프로젝트 중요도
            </Typography>
          </Grid>
          <Grid item xs={2}>
            {' '}
            <Typography variant="body2" component="div">
              {project?.prjImpt}
            </Typography>
          </Grid>
          <Grid item xs={1}>
            <Typography variant="subtitle2" component="div">
              거래처 유형
            </Typography>
          </Grid>
          <Grid item xs={2}>
            <Typography variant="body2" component="div">
              {' '}
              {project?.partnerTyp}
            </Typography>
          </Grid>
          <Grid item xs={1}>
            <Typography variant="subtitle2" component="div">
              예산여부
            </Typography>
          </Grid>
          <Grid item xs={2}>
            <Typography variant="body2" component="div">
              {' '}
              {project?.bugetYn}
            </Typography>
          </Grid>
        </Grid>
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          sx={{ py: 1, borderBottom: 1, borderColor: 'divider' }}
        >
          <Grid item xs={1}>
            <Typography variant="subtitle2" component="div">
              담당자
            </Typography>
          </Grid>
          <Grid item xs={2}>
            <Typography variant="body2" component="div">
              {project?.chargeNm}
            </Typography>
          </Grid>
          <Grid item xs={1}>
            <Typography variant="subtitle2" component="div">
              담당자 이메일
            </Typography>
          </Grid>
          <Grid item xs={2}>
            {' '}
            <Typography variant="body2" component="div">
              {project?.chargeEml}
            </Typography>
          </Grid>
          <Grid item xs={1}>
            <Typography variant="subtitle2" component="div">
              담당자 연락처
            </Typography>
          </Grid>
          <Grid item xs={5}>
            <Typography variant="body2" component="div">
              {' '}
              {project?.chargeTel}
            </Typography>
          </Grid>
        </Grid>
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          sx={{ py: 1, borderBottom: 1, borderColor: 'divider' }}
        >
          <Grid item xs={1}>
            <Typography variant="subtitle2" component="div">
              참고사항
            </Typography>
          </Grid>
          <Grid item xs={11}>
            <Typography
              variant="body2"
              component="div"
              style={{ whiteSpace: 'pre-line' }}
            >
              {project?.forcastTxt}
            </Typography>
          </Grid>
        </Grid>
      </DetailTemplate>
      <DetailTemplate title="기회분석">
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          sx={{ py: 1, borderBottom: 1, borderColor: 'divider' }}
        >
          <Grid item xs={1}>
            <Typography variant="subtitle2" component="div">
              산업체 분류
            </Typography>
          </Grid>
          <Grid item xs={3}>
            <Typography variant="body2" component="div">
              {project?.incTyp}
            </Typography>
          </Grid>
          <Grid item xs={1}>
            <Typography variant="subtitle2" component="div">
              아이템 구분
            </Typography>
          </Grid>
          <Grid item xs={3}>
            {' '}
            <Typography variant="body2" component="div">
              {project?.solutionTyp}
            </Typography>
          </Grid>
          <Grid item xs={1}>
            <Typography variant="subtitle2" component="div">
              제품 여부
            </Typography>
          </Grid>
          <Grid item xs={3}>
            <Typography variant="body2" component="div">
              {' '}
              {project?.productYn}
            </Typography>
          </Grid>
        </Grid>
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          sx={{ py: 1, borderBottom: 1, borderColor: 'divider' }}
        >
          <Grid item xs={1}>
            <Typography variant="subtitle2" component="div">
              매출처
            </Typography>
          </Grid>
          <Grid item xs={3}>
            <Typography variant="body2" component="div">
              {project?.vendorCmpNm}
            </Typography>
          </Grid>
          <Grid item xs={1}>
            <Typography variant="subtitle2" component="div">
              매출처 담당자
            </Typography>
          </Grid>
          <Grid item xs={3}>
            {' '}
            <Typography variant="body2" component="div">
              {project?.vendorEmpNm}
            </Typography>
          </Grid>
          <Grid item xs={1}>
            <Typography variant="subtitle2" component="div">
              매출 예상일
            </Typography>
          </Grid>
          <Grid item xs={3}>
            <Typography variant="body2" component="div">
              {' '}
              {project?.expDay}
            </Typography>
          </Grid>
        </Grid>

        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          sx={{ py: 1, borderBottom: 1, borderColor: 'divider' }}
        >
          <Grid item xs={1}>
            <Typography variant="subtitle2" component="div">
              PM
            </Typography>
          </Grid>
          <Grid item xs={2}>
            <Typography variant="body2" component="div">
              {project?.pmNm}
            </Typography>
          </Grid>
          <Grid item xs={1}>
            <Typography variant="subtitle2" component="div">
              PL
            </Typography>
          </Grid>
          <Grid item xs={2}>
            {' '}
            <Typography variant="body2" component="div">
              {project?.plNm}
            </Typography>
          </Grid>
          <Grid item xs={1}>
            <Typography variant="subtitle2" component="div">
              기술 담당자
            </Typography>
          </Grid>
          <Grid item xs={2}>
            <Typography variant="body2" component="div">
              {' '}
              {project?.techNm}
            </Typography>
          </Grid>
          <Grid item xs={1}>
            <Typography variant="subtitle2" component="div">
              영업 담당자
            </Typography>
          </Grid>
          <Grid item xs={2}>
            <Typography variant="body2" component="div">
              {' '}
              {project?.crtNm}
            </Typography>
          </Grid>
        </Grid>
      </DetailTemplate>

      <DetailTemplate title="원가 산출 내역">
        {project?.expDay && project?.expSales && project.expBenefitRate ? (
          <Grid
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
            sx={{ py: 1, borderBottom: 1, borderColor: 'divider' }}
          >
            <Grid item xs={1}>
              <Typography variant="subtitle2" component="div">
                매입금액
              </Typography>
            </Grid>
            <Grid item xs={3}>
              <Typography variant="body2" component="div">
                ₩{' '}
                {project?.expBuy
                  .toString()
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
              </Typography>
            </Grid>
            <Grid item xs={1}>
              <Typography variant="subtitle2" component="div">
                예상 수주금액
              </Typography>
            </Grid>
            <Grid item xs={3}>
              {' '}
              <Typography variant="body2" component="div">
                ₩{' '}
                {project?.expSales
                  .toString()
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
              </Typography>
            </Grid>
            <Grid item xs={1}>
              <Typography variant="subtitle2" component="div">
                예상 이익률
              </Typography>
            </Grid>
            <Grid item xs={3}>
              {' '}
              <Typography variant="body2" component="div">
                {project?.expBenefitRate}%
              </Typography>
            </Grid>
          </Grid>
        ) : (
          <Box>
            <Typography variant="subtitle2" component="div">
              작성된 원가 산출 내역이 없습니다.
            </Typography>
          </Box>
        )}
      </DetailTemplate>

      <DetailTemplate title="견적">
        {estimate ? (
          <>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              sx={{ py: 1, borderBottom: 1, borderColor: 'divider' }}
            >
              <Grid item xs={2}>
                <Typography variant="subtitle2" component="div">
                  견적 번호
                </Typography>
              </Grid>
              <Grid item xs={2}>
                <Typography variant="body2" component="div">
                  {estimate?.qteNo}
                </Typography>
              </Grid>
              <Grid item xs={2}>
                <Typography variant="subtitle2" component="div">
                  견적일자
                </Typography>
              </Grid>
              <Grid item xs={2}>
                <Typography variant="body2" component="div">
                  {estimate?.qteRegDt ? estimate?.qteRegDt : estimate?.crtDt}
                </Typography>
              </Grid>
              <Grid item xs={2}>
                <Typography variant="subtitle2" component="div">
                  견적 유효일자
                </Typography>
              </Grid>
              <Grid item xs={2}>
                <Typography variant="body2" component="div">
                  {estimate?.qteValidDt}
                </Typography>
              </Grid>
            </Grid>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              sx={{ py: 1, borderBottom: 1, borderColor: 'divider' }}
            >
              <Grid item xs={2}>
                <Typography variant="subtitle2" component="div">
                  총 견적 금액
                </Typography>
              </Grid>
              <Grid item xs={2}>
                <Typography variant="body2" component="div">
                  ₩{' '}
                  {estimate?.qtePrice
                    .toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                </Typography>
              </Grid>
              <Grid item xs={2}>
                <Typography variant="subtitle2" component="div">
                  유지보수기간
                </Typography>
              </Grid>
              <Grid item xs={2}>
                <Typography variant="body2" component="div">
                  {estimate?.mntTor}
                </Typography>
              </Grid>
            </Grid>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              sx={{ py: 1, borderBottom: 1, borderColor: 'divider' }}
            >
              <Grid item xs={2}>
                <Typography variant="subtitle2" component="div">
                  납품 장소
                </Typography>
              </Grid>
              <Grid item xs={10}>
                <Typography variant="body2" component="div">
                  {estimate?.destPlace}
                </Typography>
              </Grid>
            </Grid>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              sx={{ py: 1, borderBottom: 1, borderColor: 'divider' }}
            >
              <Grid item xs={2}>
                <Typography variant="subtitle2" component="div">
                  발행 조건
                </Typography>
              </Grid>
              <Grid item xs={10}>
                <Typography variant="body2" component="div">
                  {estimate?.qteCondt}
                </Typography>
              </Grid>
            </Grid>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              sx={{ py: 1, borderBottom: 1, borderColor: 'divider' }}
            >
              <Grid item xs={2}>
                <Typography variant="subtitle2" component="div">
                  결제 조건
                </Typography>
              </Grid>
              <Grid item xs={10}>
                <Typography variant="body2" component="div">
                  {estimate?.payCond}
                </Typography>
              </Grid>
            </Grid>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              sx={{ py: 1, borderBottom: 1, borderColor: 'divider' }}
            >
              <Grid item xs={2}>
                <Typography variant="subtitle2" component="div">
                  견적서 설명 1
                </Typography>
              </Grid>
              <Grid item xs={10}>
                <Typography variant="body2" component="div">
                  {estimate?.qteDesc1}
                </Typography>
              </Grid>
            </Grid>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              sx={{ py: 1, borderBottom: 1, borderColor: 'divider' }}
            >
              <Grid item xs={2}>
                <Typography variant="subtitle2" component="div">
                  견적서 설명 2
                </Typography>
              </Grid>
              <Grid item xs={10}>
                <Typography variant="body2" component="div">
                  {estimate?.qteDesc2}
                </Typography>
              </Grid>
            </Grid>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              sx={{ py: 1, borderBottom: 1, borderColor: 'divider' }}
            >
              <Grid item xs={2}>
                <Typography variant="subtitle2" component="div">
                  견적서 설명 3
                </Typography>
              </Grid>
              <Grid item xs={10}>
                <Typography variant="body2" component="div">
                  {estimate?.qteDesc3}
                </Typography>
              </Grid>
            </Grid>
          </>
        ) : (
          <Box>
            <Typography variant="subtitle2" component="div">
              현재 활성화된 견적서가 없습니다.
            </Typography>
          </Box>
        )}
      </DetailTemplate>
    </Box>
  );
};

export default ProjectDetailInfo;
